import moment from 'moment'

export const UseDateTime = (dateTime, format = 'L') => {
    return moment(dateTime).format(format)
}